import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import Checkbox from '../components/Checkbox.tsx'
import Rating from '../components/Rating.tsx'
import style from './Aside.module.scss'
import commonStyle from '../common.module.scss'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'

const Aside = () => {
  const { t } = useSurveyLocale()
  return (
    <aside className={style.leftColumn}>
      <div className={style.top}>
        <span className={style.title}>{t('questions', 'ec', 'amazon', 'ideas')}</span>
        <span>{t('questions', 'ec', 'amazon', 'idea1')}</span>
        <span>{t('questions', 'ec', 'amazon', 'idea2')}</span>
        <span>{t('questions', 'ec', 'amazon', 'idea3')}</span>
        <span>{t('questions', 'ec', 'amazon', 'idea4')}</span>
        <EmptyLink>
          <span className={`${commonStyle.link} ${commonStyle.arrowDown}`}>
            <i /> <span>{t('questions', 'ec', 'amazon', 'seeMore')}</span>
          </span>
        </EmptyLink>
        <div className={commonStyle.divider} />
        <span className={style.title}>{t('questions', 'ec', 'amazon', 'aside1')}</span>
        <EmptyLink>
          <span>
            <Checkbox />
            {t('questions', 'ec', 'amazon', 'aside2')}
          </span>
        </EmptyLink>
        <span>{t('questions', 'ec', 'amazon', 'aside3')}</span>

        <span className={style.title}>{t('questions', 'ec', 'amazon', 'aside4')}</span>
        <EmptyLink>
          <span>
            <Checkbox />
            {t('questions', 'ec', 'amazon', 'aside5')}
          </span>
        </EmptyLink>

        <span className={style.title}>{t('questions', 'ec', 'amazon', 'aside6')}</span>
        <EmptyLink>
          <span>
            <Checkbox />
            {t('questions', 'ec', 'amazon', 'aside7')}
          </span>
        </EmptyLink>
        <EmptyLink>
          <span className={`${commonStyle.link} ${commonStyle.arrowDown}`}>
            <i /> <span>{t('questions', 'ec', 'amazon', 'seeMore')}</span>
          </span>
        </EmptyLink>

        <span className={style.title}>{t('questions', 'ec', 'amazon', 'aside8')}</span>
        <EmptyLink>
          <span>
            <Checkbox />
            {t('questions', 'ec', 'amazon', 'aside9')}
          </span>
        </EmptyLink>

        <span className={style.title}>{t('questions', 'ec', 'amazon', 'aside10')}</span>
        <EmptyLink>
          <span className={commonStyle.stars}>
            <Rating size="big" rating={4} />
            <span>{t('questions', 'ec', 'amazon', 'aside11')}</span>
          </span>
        </EmptyLink>

        <span className={style.title}>{t('questions', 'ec', 'amazon', 'aside12')}</span>
        <span>{t('questions', 'ec', 'amazon', 'aside13')}</span>
        <span dangerouslySetInnerHTML={{ __html: t('questions', 'ec', 'amazon', 'todayDeals') }}></span>

        <span className={style.title}>{t('questions', 'ec', 'amazon', 'aside14')}</span>
        <EmptyLink>
          <span>
            <Checkbox />
            {t('questions', 'ec', 'amazon', 'aside15')}
          </span>
        </EmptyLink>
      </div>
    </aside>
  )
}

export default Aside
